module.exports = __webpack_public_path__ + "img/il.171fcb0c.svg";